module.exports = __webpack_public_path__ + "img/emblem.4b51063a.png";